import Typography from "@material-ui/core/Typography";
import HopDetailItem from "./HopDetailItem";
import PersonIcon from "@material-ui/icons/Person";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import DirectionsBoatIcon from "@material-ui/icons/DirectionsBoat";
import HomeWorkIcon from "@material-ui/icons/HomeWork";
import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import HopQrView from "./HopQrView";
import {makeStyles} from "@material-ui/core";

import firebaseApp from "../firebase";

import sampleFish from '../images/fish_sample.jpg'

const useStyles = makeStyles((theme) => ({
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'block',
        },
    },
    sectionMobile: {
        display: 'block',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
}));

const HopSearchResult = (props) => {
    const classes = useStyles();
    const hopData = props.data.hopProperties;

    const [showBottomPanel, setShowBottomPanel] = useState(false)
    const [fishPhoto, setFishPhoto] = useState(null)

    useEffect(()=>{
        const storage = firebaseApp.storage();
        const pathReference = storage.ref(hopData['fishPhotoUrl']);
        pathReference.getDownloadURL()
            .then(url=>{
                const xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = (event) => {
                    const blob = xhr.response;
                    // console.log(URL.createObjectURL(blob))
                    setFishPhoto(URL.createObjectURL(blob))
                };
                xhr.open('GET', url);
                xhr.send();
            })
            .catch(err=>{
                console.log(err);
            })
    }, [])


    return (
        <div>
            <div className={classes.sectionDesktop} style={{backgroundColor: '#fff', overflowY: 'auto', paddingBottom: 20, borderRadius: '5px'}}>
                <img width={450} style={{maxHeight:300}} src={fishPhoto} />
                <Typography variant="h5" style={{marginLeft: 25, marginTop: 10}}>
                    {hopData.fishType}
                </Typography>
                <Typography variant="h6" component="h2" style={{marginLeft: 25}}>
                    {hopData.quantityInKg} Kg
                </Typography>
                <HopDetailItem iconComponent={<PersonIcon/>} text={hopData.fishermanName} />
                <HopDetailItem iconComponent={<LocationOnIcon/>} text={`${hopData.latitude.toFixed(2)}, ${hopData.longitude.toFixed(2)}`} />
                <HopDetailItem iconComponent={<AccessTimeIcon/>} text={new Date(hopData.caughtOn).toLocaleString()} />
                <HopDetailItem iconComponent={<DirectionsBoatIcon/>} text={hopData.vesselName} />
                <HopDetailItem iconComponent={<HomeWorkIcon/>} text={"Sassoon Dock"} />
                <HopQrView data={props.data} />
            </div>
            <div className={classes.sectionMobile} style={
                {
                }
            }>
                <div style={
                    {
                        zIndex: 400,
                        width: '100%',
                        height: 'auto',
                        maxHeight: '70%',
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        backgroundColor: '#fff',
                        overflowY: 'auto',
                        paddingBottom: 20,
                        boxShadow: '3px 2px 8px 2px grey',
                        borderRadius: '5px'
                    }}>
                    <div onClick={()=>{
                        setShowBottomPanel(!showBottomPanel)
                    }}>
                        <img width={'100%'} style={{maxHeight:300}} src={sampleFish} />
                        <Typography variant="h5" style={{marginLeft: 25, marginTop: 10}}>
                            {hopData.fishType}Black Pomfret
                        </Typography>
                        <Typography variant="h6" component="h2" style={{marginLeft: 25}}>
                            {hopData.quantityInKg} Kg
                        </Typography>
                    </div>

                    <div
                        style={{display: showBottomPanel?'block':'none'}}
                    >

                        <HopDetailItem iconComponent={<PersonIcon/>} text={hopData.fishermanName} />
                        <HopDetailItem iconComponent={<LocationOnIcon/>} text={`${hopData.latitude.toFixed(2)}, ${hopData.longitude.toFixed(2)}`} />
                        <HopDetailItem iconComponent={<AccessTimeIcon/>} text={new Date(hopData.caughtOn).toLocaleString()} />
                        <HopDetailItem iconComponent={<DirectionsBoatIcon/>} text={hopData.vesselName} />
                        <HopDetailItem iconComponent={<HomeWorkIcon/>} text={"Sassoon Dock"} />

                        <HopQrView data={props.data} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HopSearchResult